import React from 'react';
import { COLORS } from '../../../core/constants/colors';

interface InputProps {
  label: string;
  type: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
}

export const Input: React.FC<InputProps> = ({
  label,
  type,
  value,
  onChange,
  error,
  placeholder,
  required = false,
  disabled = false,
}) => {
  return (
    <div className="mb-4 w-full">
      <label
        className="block text-sm font-medium mb-2"
        style={{ color: COLORS.primary.persianIndigo }}
      >
        {label} {required && <span style={{ color: COLORS.extended.redSalsa }}>*</span>}
      </label>
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className="w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:ring-2 transition-all disabled:opacity-60"
        style={{
          borderColor: error ? COLORS.extended.redSalsa : 'transparent',
          backgroundColor: '#F2F2F2',
          color: COLORS.primary.persianIndigo,
        }}
        onFocus={(e) => {
          if (!error) {
            e.target.style.borderColor = COLORS.user.queryButton;
          }
        }}
        onBlur={(e) => {
          if (!error) {
            e.target.style.borderColor = 'transparent';
          }
        }}
      />
      {error && (
        <p className="text-sm mt-1" style={{ color: COLORS.extended.redSalsa }}>
          {error}
        </p>
      )}
    </div>
  );
};